import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { CityService } from '@city/feature';
import { DeliveryCalculatorFormService } from '@delivery/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Suggestion } from '@spartacus/core';
import { ModalService } from '@spartacus/storefront';
import { AddressSuggestionsService } from '@yandex-maps/feature';
import { Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'ui-delivery-calculator-form',
  templateUrl: './delivery-calculator-form.component.html',
  styleUrls: ['./delivery-calculator-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AddressSuggestionsService],
  standalone: false,
})
export class DeliveryCalculatorFormComponent implements OnInit, OnDestroy {
  iconType = CUSTOM_ICON_TYPE;
  suggestions$: Observable<Suggestion[]> = this.suggestionsService.suggestions$;
  suggestIsLoading$: Observable<boolean> = this.suggestionsService.loading$;
  selectTypeahead = new EventEmitter<string>();

  private subscription = new Subscription();

  constructor(
    private cityService: CityService,
    public deliveryCalculatorFormService: DeliveryCalculatorFormService,
    private modalService: ModalService,
    private suggestionsService: AddressSuggestionsService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.selectTypeahead.pipe(debounceTime(700)).subscribe(this.suggestionsService.loadSuggestions),
    );
    this.initAddressField();
  }

  onSubmit(): void {
    this.deliveryCalculatorFormService.onSubmit();

    import('../delivery-calculator-results-modal').then((m) => {
      this.modalService.open(m.DeliveryCalculatorResultsModalComponent, { centered: true, size: 'md' });
    });
  }

  onChangeSelect(suggestion: string): void {
    this.deliveryCalculatorFormService.form.get('address').setValue(suggestion);
  }

  onBlurSelect(e: FocusEvent): void {
    const input = e.target as HTMLInputElement;
    this.deliveryCalculatorFormService.form.get('address').setValue(input.value);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private initAddressField(): void {
    this.subscription.add(
      this.cityService.activeBaseStore$.subscribe((city) => {
        this.deliveryCalculatorFormService.form.get('address').setValue(`${city.name}, `);
      }),
    );
  }
}
